const API = `${process.env.REACT_APP_BACKEND_URL}/api/chat`;

export async function chatApi(path, options = {}) {
  const res = await fetch(`${API}${path}`, {
    credentials: 'include', ...options,
    headers: { 'Content-Type': 'application/json', ...options.headers },
  });
  const data = await res.json();
  if (!res.ok) throw new Error(typeof data.detail === 'string' ? data.detail : 'No se pudo completar la solicitud. Inténtalo de nuevo.');
  return data;
}

export const messageDate = (value, locale) => value ? new Date(value).toLocaleString({ es: 'es-ES', ca: 'ca-ES', en: 'en-GB' }[locale], { day: 'numeric', month: 'short', hour: '2-digit', minute: '2-digit' }) : '';
